/**
 * Converts a date string to the format YYYY-MM-DD.
 *
 * @param {string} dateStr - The date string in ISO format (e.g., '2024-08-24T18:22:49.334Z').
 * @returns {string} - The formatted date in YYYY-MM-DD format.
 * Example usage:
 * const result = formatDate('2024-08-24T18:22:49.334Z')
 * Outputs: 2024-08-24
 */
function convertDateToIsoString(dateStr: string | Date): string {
    return new Date(dateStr).toISOString().split('T')[0]
}

export default convertDateToIsoString
